// extracted by mini-css-extract-plugin
export default {"badgesContainer":"styles_badgesContainer__cW7Gn","badges":"styles_badges__CDGQj"};